module.exports = __webpack_public_path__ + "static/surrender-2cc625795ed5ac1cafcce47af4360bd1.png";